import { FC, useEffect, useMemo } from 'react'
import { useAppStore } from '@/stores/appStore'
import { globalEnvConfig } from '@/global/config/env'
import { HSY_PAGE } from '@/global/config/iframe'
import { useShallow } from 'zustand/react/shallow'
import { GlobalStorage } from '@/global/storage'

interface Props {
  pageName: keyof typeof HSY_PAGE // 页面名称，如 '待开发票'
  className?: string
}

const HsyIframe: FC<Props> = ({ pageName, className }) => {
  const { hsyTokenRes, getHsyToken } = useAppStore(
    useShallow((state) => ({
      hsyTokenRes: state.hsyTokenRes,
      getHsyToken: state.getHsyToken,
    })),
  )

  const currentTaxNo = GlobalStorage.getStorageSync('HOME_DATA')?.uscc
  // 获取令牌
  useEffect(() => {
    if (!hsyTokenRes) {
      getHsyToken({
        taxToken: currentTaxNo,
      })
    }
  }, [hsyTokenRes, getHsyToken])

  // 构建 iframe URL
  const iframeUrl = useMemo(() => {
    if (!hsyTokenRes) return ''

    const baseUrl = globalEnvConfig.REACT_APP_HSY_URL
    const path = HSY_PAGE[pageName]?.path || ''
    const taxNo = currentTaxNo

    const url = new URL(path, baseUrl)
    url.searchParams.set('X-Access-Token', hsyTokenRes.data || '')
    url.searchParams.set('taxNo', taxNo)

    return url.toString()
  }, [hsyTokenRes, pageName])

  if (!iframeUrl) {
    return <div>正在加载...</div>
  }

  return (
    <iframe
      src={iframeUrl}
      className={className}
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  )
}

export default HsyIframe
import { FC, useEffect, useMemo } from 'react'
import { useAppStore } from '@/stores/appStore'
import { globalEnvConfig } from '@/global/config/env'
import { HSY_PAGE } from '@/global/config/iframe'
import { useShallow } from 'zustand/react/shallow'
import { GlobalStorage } from '@/global/storage'

interface Props {
  pageName: keyof typeof HSY_PAGE // 页面名称，如 '待开发票'
  className?: string
}

const HsyIframe: FC<Props> = ({ pageName, className }) => {
  const { hsyTokenRes, getHsyToken } = useAppStore(
    useShallow((state) => ({
      hsyTokenRes: state.hsyTokenRes,
      getHsyToken: state.getHsyToken,
    })),
  )

  const currentTaxNo = GlobalStorage.getStorageSync('HOME_DATA')?.uscc
  // 获取令牌
  useEffect(() => {
    if (!hsyTokenRes) {
      getHsyToken({
        taxToken: currentTaxNo,
      })
    }
  }, [hsyTokenRes, getHsyToken])

  // 构建 iframe URL
  const iframeUrl = useMemo(() => {
    if (!hsyTokenRes) return ''

    const baseUrl = globalEnvConfig.REACT_APP_HSY_URL
    const path = HSY_PAGE[pageName]?.path || ''
    const taxNo = currentTaxNo

    const url = new URL(path, baseUrl)
    url.searchParams.set('X-Access-Token', hsyTokenRes.data || '')
    url.searchParams.set('taxNo', taxNo)

    return url.toString()
  }, [hsyTokenRes, pageName])

  if (!iframeUrl) {
    return <div>正在加载...</div>
  }

  return (
    <iframe
      src={iframeUrl}
      className={className}
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  )
}

export default HsyIframe
